export default [
    {
        path: '/shipment-carrier-settings/list',
        name: 'shipment_carrier_settings_list',
        component: () => import('@src/shipment-carrier-settings/list.vue'),
        meta: {
            title: 'Versanddienstleister-Einstellungen',
            role: 'ROLE_SHIPMENT_CARRIER',
        },
    },
    {
        path: '/shipment-carrier-settings/:id',
        name: 'shipment_carrier_settings_detail',
        component: () => import('@src/shipment-carrier-settings/detail.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            role: 'ROLE_EDIT_SHIPMENT_CARRIER_SETTINGS',
        },
    },
];
